import * as types from './types';

const savedItems = localStorage.getItem('cart_items');
const initialState = {
  items: savedItems ? JSON.parse(savedItems) : [], // { product, quantity, variationId? }
};

const cartReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case types.ADD_TO_CART: {
      const existingIndex = state.items.findIndex(
        (item) => item.product.id === action.payload.product.id && item.variationId === action.payload.variationId
      );
      if (existingIndex >= 0) {
        const newItems = [...state.items];
        newItems[existingIndex].quantity += action.payload.quantity;
        newState = { ...state, items: newItems };
      } else {
        newState = { ...state, items: [...state.items, action.payload] };
      }
      break;
    }
    case types.REMOVE_FROM_CART:
      newState = {
        ...state,
        items: state.items.filter(
          (item) => !(item.product.id === action.payload.productId && item.variationId === action.payload.variationId)
        ),
      };
      break;
    case types.UPDATE_CART_QUANTITY: {
      const newItems = state.items.map((item) => {
        if (item.product.id === action.payload.productId && item.variationId === action.payload.variationId) {
          return { ...item, quantity: action.payload.quantity };
        }
        return item;
      });
      newState = { ...state, items: newItems };
      break;
    }
    case types.CLEAR_CART:
      newState = { ...state, items: [] };
      break;
    default:
      return state;
  }
  localStorage.setItem('cart_items', JSON.stringify(newState.items));
  return newState;
};

export default cartReducer;
